import React from 'react';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import DatosEmpadronador from './DatosEmpadronador'
import DatosDPI from './DatosDPI'
import DatosUsuario from './DatosUsuario'
import EstatusUsuario from './EstatusUsuario'
import DatosDiscapacidades from './DatosDiscapacidades'

function DatosCiudadano(props) {   
    const classes = useStyles()
    return (

        <div>
            <DatosEmpadronador/>
            <DatosDPI />
            <DatosUsuario />
            <EstatusUsuario open={props.open}/>
            {/* <DatosDiscapacidades /> */}
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);